module.exports = __webpack_public_path__ + "static/media/hp_logo.d3b46703.png";